import { useSyncExternalStore } from 'react';
import { create } from 'zustand';

import { Icone } from '../componentes/Icone';

/**
 * Janela estreita (< 768 px no navegador): a barra de servidores e a lateral
 * viram uma gaveta que abre pelo botão do cabeçalho, e a lista de membros
 * some. A interface de celular de verdade é o app (fase 7).
 */
const CONSULTA = '(max-width: 767px)';

// Sem `matchMedia` (testes no jsdom): janela larga.
const consulta = () =>
  typeof window.matchMedia === 'function' ? window.matchMedia(CONSULTA) : null;

function assinar(avisar: () => void) {
  const lista = consulta();
  lista?.addEventListener('change', avisar);
  return () => lista?.removeEventListener('change', avisar);
}

export function useJanelaEstreita(): boolean {
  return useSyncExternalStore(
    assinar,
    () => consulta()?.matches ?? false,
    () => false,
  );
}

export const useGaveta = create<{ aberta: boolean }>(() => ({
  aberta: false,
}));

export function abrirGaveta() {
  useGaveta.setState({ aberta: true });
}

export function fecharGaveta() {
  useGaveta.setState({ aberta: false });
}

/** O botão ☰ do cabeçalho; só aparece com a janela estreita. */
export function BotaoGaveta() {
  const estreita = useJanelaEstreita();
  if (!estreita) return null;
  return (
    <button
      type="button"
      aria-label="Abrir canais e servidores"
      onClick={abrirGaveta}
      className="-ml-1 flex size-8 shrink-0 items-center justify-center rounded-md text-texto-2 hover:bg-hover hover:text-texto"
    >
      <Icone nome="menu" tamanho={20} />
    </button>
  );
}
